import React from 'react';
import { Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Page, Div } from '../../../framework';
import Menu from '../../../component/Menu/Menu';
import { Link } from 'react-router-dom';

import './ResetPasswordExpired.scss';

const { Title, Paragraph } = Typography;

const ResetPasswordExpiredPage = () => {
  return (
    <Page className='page-reset-password-expired'>
      <Helmet>
        <title>Reset Password Link Expired</title>
        <meta name='description' content='Auth page for react starter' />
      </Helmet>
      <Div className='mobile-view'>
        <Menu />

        <Div>
          <Title level={2}>Reset Password Link Expired</Title>
          <Paragraph>
            Looks like the link you&apos;re trying to open isn&apos;t working.
            It might be expired or just not right. Try{' '}
            <Link to='/auth/talent/forgot-password'>reset password</Link> again.
          </Paragraph>
        </Div>
      </Div>
    </Page>
  );
};

export default ResetPasswordExpiredPage;
